import * as React from 'react';
import { CardWithDate } from '../../../../../store/calendar/selectors';
import { getDatePeriod } from '../../../../../utils';
import BookChip from '../../../../BookCalendar/BooksSidebar/BookChip/BookChip';
import CardPopup from './CardPopup/CardPopup';
import cn from 'classnames';

interface Props {
	card: CardWithDate;
	startInOtherMonth?: boolean;
	hidePeriod?: boolean;
}

const CardInner: React.FC<Props> = ({ card, startInOtherMonth, hidePeriod }) => {
	const [open, setOpen] = React.useState(false);

	const show = () => setOpen(true);
	const close = () => setOpen(false);

	return (
		<div data-card-id={card.card.eId}>
			{!hidePeriod && <div className="mobile-calendar-month-group__period">
				{getDatePeriod(card.startDate, card.endDate)}
			</div>}

			<BookChip
				className={cn("mobile-calendar-month-group__book", {
					'mobile-calendar-month-group__book_otherMonth': startInOtherMonth
				})}
				card={card.card}
				onClick={show}
			/>

			<CardPopup card={card} open={open} onClose={close} />
		</div>
	);
};

export default CardInner;
